var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.46409 1.14331C7.33007 1.14757 7.20292 1.20392 7.10974 1.30037C5.85962 2.55323 4.3821 3.82185 3.05853 5.11388L0.827616 3.44265C0.718176 3.35992 0.580294 3.32415 0.444406 3.3432C0.308591 3.36232 0.185898 3.43465 0.103503 3.54436C0.0210415 3.65407 -0.014261 3.79208 0.00525496 3.92789C0.0247709 4.06371 0.0975097 4.18615 0.207475 4.2682L2.78471 6.20121H2.78464C2.88422 6.27635 3.00758 6.31292 3.13201 6.30399C3.25644 6.29513 3.37333 6.24144 3.4612 6.15292C4.81223 4.79903 6.44444 3.4304 7.84253 2.02924H7.8426C7.94338 1.93186 8.0002 1.79771 8 1.65756C7.9998 1.51741 7.94251 1.38347 7.8414 1.28641C7.74029 1.18942 7.60407 1.13773 7.46399 1.14326L7.46409 1.14331Z",
    fill: "#827677"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.c3cd3956443f4d4c19927af3fdb8f6ec.svg";
export { ForwardRef as ReactComponent };